/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const ADMIN_CAN_ABILITY = [
  //Route Access

  ['read', 'MyPolicies'],
  ['read', 'MyAccount'],
  ['read', 'MyPoliciesDetail'],
  ['read', 'ProvisionalPolicies'],
  ['read', 'ActualPolicies'],
  ['read', 'SupplyChainList'],
];

export const ADMIN_CANNOT_ABILITY = [
  //Route Access Denial
  //  ["read", "Button"],
];
